import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Badge from 'react-bootstrap/Badge';

const excludedCountries = [
  "GB",
  "UK",
];

const MoonpayButton = (props) => {
  const { location } = props;
  if (!location || excludedCountries.includes(location)) {
    return <></>
  }

  const popover = (
    <Popover id="popover-sponsor">
      <Popover.Title>
        MoonPay: 50% off MoonPay fees with a credit card, debit card or bank transfer.&nbsp;
        <span className="small"><Badge variant="secondary">SPONSORED</Badge></span>
      </Popover.Title>
      <Popover.Content>
        Buy XRP with 50% off MoonPay Fees, for your first 5 transactions.
        T&C's apply, new users only and not for UK users.
      </Popover.Content>
    </Popover>
  );

  return (
    <span>
        <OverlayTrigger
          key={'bottom'}
          placement={'bottom'}
          overlay={popover}
        >
          <Button
            variant="info"
            size="sm"
            href="https://api.xrpscan.com/api/v1/campaign/moonpaybutton"
            target="_blank"
            rel="noopener nofollow"
            className="dropdown-toggle"
          >50% off MoonPay fees for XRP</Button>
        </OverlayTrigger>
    </span>
  )
}

MoonpayButton.propTypes = {
  location: PropTypes.string.isRequired,
}

export default MoonpayButton;